
//import FrustumMeshWorker = require('./frustumMeshWorker');

import * as FrustumMeshWorker from './frustumMeshWorker';
import * as FrustumStructures from './frustumStructures';
import * as BABYLON from 'babylonjs';
export var CollisionWorker = "";


export interface IFrustumMeshCoordinator {

    getUpdatedNodeStatus(collisionIndex: number, maximumRetry: number, cameraPosition: BABYLON.Vector3, cameraDirection: BABYLON.Vector3, planes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport, onUpdatedNodes: (sceneManager: any, visibleNodes: BABYLON.SmartArray<FrustumStructures.TreeNode>, hiddenNodes: BABYLON.SmartArray<FrustumStructures.TreeNode>) => any): void;
    init(sceneManager: any, scene: BABYLON.Scene): void;
    destroy(): void;
    onNodeRemoved(node: FrustumStructures.TreeNode): void;

    onOctreeBlockContentAdded(node: FrustumStructures.TreeNode): void;
    onNodeRemoved(node: FrustumStructures.TreeNode): void;
}


export interface SerializedFrustumMeshToWorker {
    // Cam properties
}

export interface InitPayload {

}


export class FrustumMeshCoordinatorWorker implements IFrustumMeshCoordinator {

    private _scene: BABYLON.Scene;
    private _sceneManager: any;
    private _scaledPosition = BABYLON.Vector3.Zero();
    private _scaledVelocity = BABYLON.Vector3.Zero();

    private _updateNodesCallbackArray: Array<(sceneManager: any, visibleNodes: BABYLON.SmartArray<FrustumStructures.TreeNode>, hiddenNodes: BABYLON.SmartArray<FrustumStructures.TreeNode>) => void>;
    private _init: boolean;
    private _runningUpdated: number;
    private _runningCollisionTask: boolean;
    private _worker: Worker;

    private _blockContentToAdd: { [n: string]: FrustumStructures.TreeNode; }
    private _blocksToAdd: FrustumMeshWorker.OctreeBlock<FrustumStructures.TreeNode>[] = [];

    private _addUpdateNodeList: { [n: string]: FrustumStructures.TreeNode; }
    private _toRemoveNodesArray: Array<string>;

    constructor() {
        this._updateNodesCallbackArray = [];
        this._init = false;
        this._runningUpdated = 0;
        this._runningCollisionTask = false;
    }

    public getUpdatedNodeStatus(collisionIndex: number, maximumRetry: number, cameraPosition: BABYLON.Vector3, cameraDirection: BABYLON.Vector3, planes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport, onUpdatedNodes: (sceneManager: any, visibleNodes: BABYLON.SmartArray<FrustumStructures.TreeNode>, hiddenNodes: BABYLON.SmartArray<FrustumStructures.TreeNode>) => any): void {
        if (!this._init) return;

        if (this._updateNodesCallbackArray[collisionIndex] || this._updateNodesCallbackArray[collisionIndex + 100000]) return;

        this._updateNodesCallbackArray[collisionIndex] = onUpdatedNodes;


        var payload: FrustumStructures.FrustumMeshPayload = {

            planes: planes,
            cameraPosition: cameraPosition,
            cameraDirection: cameraDirection,
            collisionId: collisionIndex,
            maximumRetry: maximumRetry,
            transformation: transformation,
            viewport: viewport
        };

        var message: FrustumStructures.FrustmMeshMessage = {
            payload: payload,
            taskType: FrustumStructures.WorkerTaskType.ORDERNODES
        }
        this._worker.postMessage(message);

    }

    public init(sceneManager: any, scene: BABYLON.Scene): void {
        this._scene = scene;
        this._sceneManager = sceneManager;
        this._scene.registerAfterRender(this._afterRender);

        this._blockContentToAdd = {};
        this._blocksToAdd = [];

        this._worker = new Worker(new URL('./frustumMeshWorker.ts', import.meta.url), { type: 'module' });
        this._worker.onmessage = this._onMessageFromWorker;
        var message: FrustumStructures.FrustmMeshMessage = {
            payload: {},
            taskType: FrustumStructures.WorkerTaskType.INIT
        }

        this._worker.postMessage(message);
    }

    public destroy(): void {
        this._scene.unregisterAfterRender(this._afterRender);
        this._worker.terminate();
    }


    OnOctreeBlockAdded(block: FrustumMeshWorker.OctreeBlock<FrustumStructures.TreeNode>) {

        this._blocksToAdd.push(block);
    }
    public onOctreeBlockContentAdded(node: FrustumStructures.TreeNode) {

        // Add node into octree (or something like this).
        this._blockContentToAdd[node.id] = node;
    }
    public onNodeRemoved(node: FrustumStructures.TreeNode) {

        this._toRemoveNodesArray.push(node.id);
    }

    private _afterRender = () => {

        if (!this._init) return;

        if (this._blocksToAdd.length == 0) {
            return;
        }

        //TODO make sure update runs as fast as possible to be able to update 60 FPS.
        if (this._runningUpdated > 1) {
            return;
        }

        ++this._runningUpdated;

        var payload: FrustumStructures.UpdatePayload = {
            updatedBlocks: this._blocksToAdd,
            updatedBlockContent: this._blockContentToAdd,
            removedNodes: this._toRemoveNodesArray
        };
        var message: FrustumStructures.FrustmMeshMessage = {
            payload: payload,
            taskType: FrustumStructures.WorkerTaskType.UPDATE
        }
        var serializable: any = [];

        this._worker.postMessage(message, serializable);

        this._addUpdateNodeList = {};
        this._blockContentToAdd = {};
        this._blocksToAdd = [];
        this._toRemoveNodesArray = [];
    }

    private _onMessageFromWorker = (e: MessageEvent) => {
        var returnData = <FrustumStructures.WorkerReply>e.data;
        if (returnData.error != FrustumStructures.WorkerReplyType.SUCCESS) {

            BABYLON.Tools.Warn("error returned from worker!");
            return;
        }

        switch (returnData.taskType) {
            case FrustumStructures.WorkerTaskType.INIT:
                this._init = true;

                break;
            case FrustumStructures.WorkerTaskType.UPDATE:
                this._runningUpdated--;
                break;
            case FrustumStructures.WorkerTaskType.ORDERNODES:
                this._runningCollisionTask = false;
                var returnPayload: FrustumStructures.FrustumMeshReplyPayload = returnData.payload;
                if (!this._updateNodesCallbackArray[returnPayload.collisionId]) return;

                this._updateNodesCallbackArray[returnPayload.collisionId](this._sceneManager, returnPayload.visibleNodes, returnPayload.hiddenNodes);

                //cleanup
                this._updateNodesCallbackArray[returnPayload.collisionId] = undefined;
                break;
        }
    }
}